// @flow
import React, { type Node } from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import './UserContent.scss';

type Props = {
  type: string,
  username: string,
  children: Node,
  side: Node,
};

const UserContent = ({ type, children, side, username }: Props) => (
  <div className="UserContent">
    <div className="tab">
      <Link className={cx({ active: type === 'posts' })} to={`/@${username}`}>
        포스트
      </Link>
      <Link className={cx({ active: type === 'products' })} to={`/@${username}/products`}>
        상품
      </Link>
      <Link className={cx({ active: type === 'series' })} to={`/@${username}/series`}>
        시리즈
      </Link>
      <Link className={cx({ active: type === 'history' })} to={`/@${username}/history`}>
        활동
      </Link>
      <Link className={cx({ active: type === 'about' })} to={`/@${username}/about`}>
        소개
      </Link>
    </div>
    <div className="contents">
      {side && <div className="side-wrapper">{side}</div>}
      <div className="tab-wrapper">{children}</div>
    </div>
  </div>
);

export default UserContent;



// WEBPACK FOOTER //
// ./src/components/user/UserContent/UserContent.js